import React, { Suspense } from 'react'
import { PreviewAlert } from '../../elements'
import styles from './Page.module.scss'
import { DynamicComponent } from '~elements'
import { useModal } from 'utils/hooks/useModal'
import { isComponentOfType } from 'utils'
import { PageProps, LostandFoundProps, ModalProps } from '~types'
import Image from 'next/image'

const Page = ({ content, preview, lostandfoundData }: PageProps) => {
  const { body } = content
  const { blocks = [], backgroundImageXl } = body || {}

  // Manage Modals that open on page load
  const { isModalOpen, closeModal } = useModal(true)
  const componentsList = Array.isArray(blocks)
    ? blocks.map(block => {
        const isLostandFoundComponent = isComponentOfType<LostandFoundProps>(block, 'LostandFound')
        const isModalComponent = isComponentOfType<ModalProps>(block, 'Modal')
        // Safety check to prevent non event announcement modals from opening on page load
        if (isModalComponent && block?.view?.componentName !== 'ModalViewEventAnnouncement') return

        const enhancedBlock = {
          ...block,
          ...(isModalComponent && {
            handleModalClose: () => {
              closeModal()
            },
            isOpen: isModalOpen,
            width: 'md' as const,
            hasBorder: true
          }),
          ...(isLostandFoundComponent && { lostandfoundData: lostandfoundData })
        }

        return <DynamicComponent key={block?.id} block={enhancedBlock} />
      })
    : null

  return (
    <main>
      {backgroundImageXl?.url && (
        <Image
          src={backgroundImageXl?.url}
          alt={backgroundImageXl?.altText || ''}
          style={{
            objectFit: 'cover',
            backgroundPosition: 'top center'
          }}
          fill
        />
      )}
      <Suspense fallback={<div>Loading...</div>}>{componentsList}</Suspense>
      {preview && (
        <div className={styles.previewAlertContainer}>
          <PreviewAlert />
        </div>
      )}
    </main>
  )
}

export default Page
